// extracted by mini-css-extract-plugin
export var formContainer = "_ke-0";
export var message = "_ke-1";